<template>
  <div>
    <div class="grid-content maintitle">
      <span>内容维度</span>
    </div>

    <div class="grid-content content-margin">
      <div class="buttonarea">
        <el-link :underline="false">
          <el-button size="medium" round @click.native="refresh">
            <i class="iconfont">&#xe667;</i>
            {{ $t("message.刷新") }}
          </el-button>
        </el-link>
        
        <el-link :underline="false">
          <el-button size="medium" round @click.native="exportData">
            <i class="iconfont">&#xe667;</i>
            {{ $t("message.导出") }}
          </el-button>
        </el-link>
        <el-link :underline="false">
          <el-button size="medium" round @click.native="viewTask">
            查看导出任务
          </el-button>
        </el-link>
      </div>
    </div>

    <div class="grid-content content-margin">
      <el-divider></el-divider>
      <table class="simpleRow">
        <tr>
          <td>
            <span class="simpleLabel">ID</span>
          </td>
          <td>
            <el-input clearable prefix-icon="el-icon-search" v-model="filterBody.id" size="small" @change="refresh"
              placeholder="输入ID" />
          </td>
          <td style="padding-left: 20px">
            <span class="simpleLabel">标题</span>
          </td>
          <td>
            <el-input clearable prefix-icon="el-icon-search" v-model="filterBody.title" size="small" @change="refresh"
              placeholder="输入标题" />
          </td>

          <td>
            <span class="simpleLabel">{{ $t("message.分类") }}</span>
          </td>
          <td>
             <el-cascader
              size="small"
              style="width: 175px"
              v-model="selectedClassify"
              :options="classifyGroup"
              :props="{ checkStrictly: true }"
              @change="handleClassifyChange"
              :placeholder="$t('message.请选择')"
              clearable>
              </el-cascader>
          </td>

          <td style="padding-left: 20px">
            <span class="simpleLabel">开始日期</span>
          </td>
          <td>
            <el-date-picker v-model="filterBody.date.fromdate" type="date" placeholder="选择日期">
            </el-date-picker>
          </td>

          <td style="padding-left: 20px">
            <span class="simpleLabel">结束日期</span>
          </td>
          <td>
            <el-date-picker v-model="filterBody.date.todate" type="date" placeholder="选择日期">
            </el-date-picker>
          </td>

          <td style="padding-left: 20px">
            <el-button type="primary" size="mini" style="float: right" @click="refresh">检索</el-button>
          </td>
        </tr>
      </table>
    </div>

    <div class="grid-content content-margin">
      <el-table ref="table" :data="articleList" stripe border :height="tableHeight" style="width: 100%" @sort-change="filterFunc">
        <el-table-column prop="article.id" label="ID" width="125">
        </el-table-column>

        <el-table-column prop="article.createdate" label="发布时间" width="250">
        </el-table-column>

        <el-table-column prop="article.title" label="标题"> </el-table-column>

        <el-table-column prop="firstCategory" label="所属一级菜单" width="125">
        </el-table-column>

        <el-table-column prop="secondCategory" label="所属二级菜单" width="125">
        </el-table-column>

        <el-table-column prop="pv" label="访问次数" width="125" sortable="true">
        </el-table-column>

        <el-table-column prop="uv" label="访问人数" width="125" sortable="true">
        </el-table-column>

        <el-table-column prop="share" label="转发次数" width="125" sortable="true">
        </el-table-column>

        <el-table-column prop="download" label="下载量" width="125" sortable="true">
        </el-table-column>

        <el-table-column prop="readTime" label="平均阅读时间（分钟）" width="125" sortable="true">
        </el-table-column>

        <el-table-column prop="readCompletion" label="平均阅读完完成率" width="150" sortable="true">
        </el-table-column>
      </el-table>

      <!-- 分页组件 -->
      <pagination :pagesizeList="pageConfig.pagesizeList" :pagesize="pagingBody.pageConfig.pagesize"
        :total="pageConfig.total" :page="pagingBody.pageConfig.page"></pagination>
    </div>
    <el-drawer
      title="导出任务列表"
      :visible.sync="drawerSetting.show"
      >
      <el-table
    :data="drawerSetting.tableData"
    height="600"
    border
    style="width: 100%">
    <el-table-column
      prop="createDate"
      label="导出日期"
      width="180">
    </el-table-column>
    <el-table-column
      prop="stateDesc"
      label="导出状态"
      width="180">
      <template slot-scope="scope">
        <el-button v-if="scope.row.stateDesc=='已完成'" @click="downloadFunc(scope.row)">下载</el-button>
        <span v-else>{{scope.row.stateDesc}}</span>
      </template>
    </el-table-column>
    
  </el-table>
    </el-drawer>
    <a :href="url" style="display: none" ref="aclick"></a>
  </div>
</template>

<script>
// 分页模块
import pagination from "@/components/pagination/pagination";
import exportFile from "@/components/export-import/exportFile";
import { rejecthttp, changeflagCLOSED } from "@/utils/request";
import commonUtil from "@/utils/commonUtil";
  import store from '@/store/index.js'

export default {
  name: "ArticleDimension",
  components: {
    pagination,
    exportFile
  },
  data() {
    return {
      //检索数据
      filterBody: {},
      tableHeight: 500,

      //获取列表
      articleList: [],
      classifyGroup:[],
      selectedClassify:[],

      // 分页
      pageConfig: {
        pagesizeList: [20, 50, 100],
        total: null,
      },

      pagingBody: {
        appID: 188,
        filterConfig: {},
        pageConfig: {
          page: 1,
          pagesize: 20,
          pageStartIndex: 0,
        },
        sortConfig: {},
      },

      url: '',

      sendData: {
        appID: 188,
        filterConfig: {
          keyword: "",
          type: null,
          date: { fromdate: null, todate: null},
        },
        pageConfig: {
          page: 1,
          pagesize: 20,
          pageStartIndex: 0,
        },
        sortConfig: {
          order: "",
          prop: "",
        },
      },
      drawerSetting:{
        show:false,
        tableData:[]
      }
    };
  },
  mounted: function () {
    this.$nextTick(function () {
      if (this.$refs.table.$el !== "undefined")
        this.tableHeight =
          window.innerHeight - this.$refs.table.$el.offsetTop - 195;

      // 监听窗口大小变化
      let self = this;
      window.onresize = function () {
        self.tableHeight =
          window.innerHeight - self.$refs.table.$el.offsetTop - 195;
      };
    });
    //this.$refs.table.$el.offsetTop：表格距离浏览器的高度 //50表示你想要调整的表格距离底部的高度（你可以自己随意调整），因为我们一般都有放分页组件的，所以需要给它留一个高度
  },
  watch: {},
  methods: {
  downloadFunc(row){
    fetch('/rs/exportfile/bigcsvdownload'+`?handlekey=${row.handleKey}`,{
                    method:'get',
                    headers:new Headers({
                        DMFSession:store.state.DMFSession
                    })
                }).then(res=>res.blob())
                .then(data=>{
                    const bloburl=window.URL.createObjectURL(data)
                    const a=document.createElement('a')
                    function name(){
                    return row.createDate+'资源导出'
                    }
                
                  let r=''
                
                     r=name()
                    a.download=r+'.zip'
                    a.href=bloburl
                    a.click()
                })

  },
  viewTask(){
      this.drawerSetting.show=true
      rejecthttp(false,'get','/manage/user/getexporttask',{},this,(doc) => {
          changeflagCLOSED(doc, 0, this);
          if (doc.data.Code == "MSGKEY_OK") {
              this.drawerSetting.tableData=doc.data.data
              this.drawerSetting.tableData.forEach((any) => {
              any.createDate = commonUtil.formatDate(
                any.createDate
              );
            });
          }
        }
      );
  },
    exportData(){
    this.pagingBody.filterConfig = JSON.parse(
        JSON.stringify(this.filterBody)
      );
      let t=JSON.parse(JSON.stringify(this.pagingBody))
      t.pageConfig.pagesize=999999999
      rejecthttp(false,'post','/manage/user/exportarticledimension',t,this,(doc) => {
          changeflagCLOSED(doc, 1, this);
          if (doc.data.Code == "MSGKEY_OK") {
          //   this.$message({
          //   type: "info",
          //   message: "员工导出接口ok",
          // });
         

          }
        }
      );
    },
    paginationChange(pagesize, page, name) {
      this.pagingBody.pageConfig.page =
        page != -1 ? page : this.pagingBody.pageConfig.page;
      this.pagingBody.pageConfig.pagesize =
        pagesize != -1 ? pagesize : this.pagingBody.pageConfig.pagesize;
        this.pagingBody.pageConfig.pageStartIndex = 
        (this.pagingBody.pageConfig.page-1) * this.pagingBody.pageConfig.pagesize;
      this.refresh();
    },
    getClassifyGroup() {
      this.$http
        .get("/manage/classify/getvalidlist", {
          params: {
            appid: this.pagingBody.appID
          },
        })
        .then((doc) => {
          if (doc.data.Code != "MSGKEY_OK") {
            this.$message({
              type: "error",
              message: doc.data.Message,
            });
          } else {
            this.classifyGroup = [];
            doc.data.data.firstGroup.forEach((value,index,array) => {
              var filterlist = doc.data.data.secondGroup.filter((a)=>{if(a.parentid===value.classifyid)return true});
              var children = [];
              filterlist.forEach((value,index,array)=>{
                var obj = {'value':value.classifyid,'label':value.name};
                children.push(obj);
              })
              var obj;
              if(children.length>0){
                obj = {'value':value.classifyid,'label':value.name,'children':children};
              }else{
                obj = {'value':value.classifyid,'label':value.name};
              }
              this.classifyGroup.push(obj);
            });
          }
        });
    },
    handleClassifyChange(value) {
        this.selectedClassify = value;
        if(value.length===0)
        { 
          this.filterBody.secondCategoryId = null;
          this.filterBody.firstCategoryId = null;
        }
        if(value.length===1){
          this.filterBody.secondCategoryId = null;
          this.filterBody.firstCategoryId = value[0];
        }
        if(value.length===2){
          this.filterBody.secondCategoryId = value[1];
          this.filterBody.firstCategoryId = value[0];
        }
      },
// 排序的回调
    filterFunc(config){
      // 获取点击的dom保存下来，等待翻页后继续留用
      // 获取dom元素
      this.pagingBody.pageConfig.page=1
      this.pagingBody.sortConfig.order=config.order
      this.pagingBody.sortConfig.prop=config.prop
      this.refresh();
        // 保存排序的dom标签
      // this.clickDom=orderDom
    },
    downloadCsv() {
      this.pagingBody.filterConfig = JSON.parse(
        JSON.stringify(this.filterBody)
      );

      rejecthttp(
        false,
        "post",
        "/manage/user/exportarticledimension",
        this.pagingBody,
        this,
        (doc) => {
          changeflagCLOSED(doc, 0, this);
          if (doc.data.Code == "MSGKEY_OK") {
            this.url = "/rs/exportdownload/bigcsv?handlekey=" + doc.data.data;
            console.log("aaaaaaaaa", this.url);
            this.openCsv(this.url);
          }
        }
      );
    },

    openCsv(url) {
      this.$confirm("文件导出完成", "提示", {
        confirmButtonText: "下载",
        cancelButtonText: "取消",

        type: "info",
      })
        .then(() => {
          this.$refs.aclick.click();
          this.$message({
            type: "success",
            message: "正在下载!",
          });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消下载",
          });
        });
    },

    resetFilterBody() {
      this.filterBody = {
        id: "",
        title: "",
        date: { fromdate: null, todate: null},
      };
    },

    refresh() {
      this.pagingBody.filterConfig = JSON.parse(
        JSON.stringify(this.filterBody)
      );
      rejecthttp(
        false,
        "post",
        "/manage/user/articledimension",
        this.pagingBody,
        this,
        (doc) => {
          changeflagCLOSED(doc, 0, this);
          if (doc.data.Code == "MSGKEY_OK") {
            console.log(doc.data);

            this.pageConfig.total = doc.data.exData.datas;
            this.articleList = doc.data.data;
            this.articleList.forEach((any) => {
              any.article.createdate = commonUtil.formatDate(
                any.article.createdate
              );
            });
          }
        }
      );
    },
  },
  created() {
    this.resetFilterBody();
    this.refresh();
    this.getClassifyGroup();
  },
  computed: {},
};
</script>

<style scoped>
.el-table /deep/ td {
  user-select: text !important;
}

.serachSpan {
  width: 7%;
}

.serachText {
  width: 13%;
}

.serachInput {
  width: 100%;
}
</style>



// WEBPACK FOOTER //
// src/pages/vipcenter/ArticleDimension.vue